import React from 'react'
import Select from 'react-select'
import { Controller } from 'react-hook-form'
import makeAnimated from 'react-select/animated'
import styles from './Checkout.module.scss'
import Grid from "../../Grid"
import Image from "../../Image"
import creditCardLogo from '../../../assets/card.png'
import NumberFormat from "react-number-format"
import PlacesAutocompleteField from '../../common/Forms/PlacesAutocompleteField'
import usePaymentInputs from 'react-payment-inputs/lib/usePaymentInputs'

const animatedComponents = makeAnimated();

const CardForm = ({ app, register, errors, control, usStates, setValue, trigger, isClearpay }) => {
  const limit = (val, max) => {
    if (val.length === 1 && val[0] > max[0]) {
      val = '0' + val;
    }

    if (val.length === 2) {
      if (Number(val) === 0) {
        val = '01';

      } else if (val > max) {
        val = max;
      }
    }

    return val;
  }

  const cardExpiry = (val) => {
    const month = limit(val.substring(0, 2), '12');
    const year = val.substring(2, 4);

    return month + (year.length ? '/' + year : '');
  }

  const { meta, getCardNumberProps } = usePaymentInputs()

  const renderCardInput = () => {
    return (
      <React.Fragment>
        <label className={styles.label}>Name on Card:</label>
        <input
          className={`${styles.input} ${errors.name_on_card && styles.error}`}
          {...register("name_on_card", { required: !isClearpay })}
        />

        <div className={styles.cardInfo}>
          <div className={styles.cardNumberContainer}>
            <label className={styles.cardDataLabel}>
              <Image src={creditCardLogo} />
            </label>
            <input
              inputMode="numeric"
              type="text"
              className={`${styles.input} ${errors.card_number && styles.error}`}
              {...register('card_number', {
                required: { value: !isClearpay, message: 'Credit card number is required' },
                minLength: {
                  value: 15,
                  message: "Credit card must be at least 15 numbers"
                },
              })}
            />
          </div>

          <div className={styles.cardNumberContainer}>
            <label className={styles.cardDataLabel}>
              EXP.
            </label>
            <Controller
              control={control}
              name="card_expires_on"
              render={({ value }) => (
                <NumberFormat
                  format={cardExpiry}
                  placeholder="MM/YY"
                  className={errors.card_expires_on && styles.error}
                  inputMode='numeric'
                  value={value}
                  onValueChange={(v) => {
                    setValue('card_expires_on', v.formattedValue);
                    if (errors.card_expires_on) trigger('card_expires_on');
                  }}
                />
              )}

              rules={{ required: !isClearpay, minLength: { value: 5, message: "Expiration date must be at least 5 characters with a '/'" } }}
            />

            <label className={styles.cardDataLabel}>
              CVV
            </label>
            <input
              className={errors.card_verification && styles.error}
              type="number"
              inputMode='numeric'
              {...register("card_verification",
                { required: !isClearpay,
                  minLength: {
                    value: 3,
                    message: "CVV must be at least 3 numbers"
                  }})}
            />
          </div>
        </div>

        {errors.card_number && errors.card_number.message && (
          <p className={styles.errorMessage}>{errors.card_number.message}</p>
        )}

        {errors.card_expires_on && errors.card_expires_on.message && (
          <p className={styles.errorMessage}>{errors.card_expires_on.message}</p>
        )}

        {errors.card_verification && errors.card_verification.message && (
          <p className={styles.errorMessage}>{errors.card_verification.message}</p>
        )}
      </React.Fragment>
    )
  }

  return (
    <div>
      {!isClearpay && renderCardInput()}

      <h2 className={styles.header}>
        {app ? '4' : '3'}. Billing Info
      </h2>

      <label className={styles.label}>Address Line 1</label>
      <PlacesAutocompleteField
        inputClassName={`${styles.input} ${errors.address && styles.error}`}
        setValue={setValue}
        control={control}
        inputName="address"
      />

      <label className={styles.label}>Address Line 2 (Apt. / Unit #)</label>
      <input
        className={`${styles.input} ${errors.address2 && styles.error}`}
        {...register("address2")}
      />

      <Grid container>
        <Grid item xs={8}>
          <label className={styles.label}>City</label>
          <input
            className={`${styles.input} ${errors.city && styles.error}`}
            {...register("city", { required: true })}
          />
        </Grid>
        <Grid item xs={1} />

        <Grid item xs={3}>
          <label className={styles.label} />
          <Controller
            control={control}
            defaultValue={{ value: 'CA', label: 'CA' }}
            name="state"
            render={({ field, value }) => (
              <Select
                {...field}
                className="basic-single"
                components={animatedComponents}
                defaultValue={{ value: 'CA', label: 'CA' }}
                options={usStates}
                name="state"
                value={usStates.find(s => s.value === value)}
              />)}
          />
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={8}>
          <label className={styles.label}>Zip Code</label>
          <input
            className={`${styles.input} ${errors.zip_code && styles.error}`}
            type="number"
            inputMode='numeric'
            {...register("zip_code",
              { required: true,
                minLength: {
                  value: 5,
                  message: "ZIP code must be at least 5 numbers"
                }})}
          />
        </Grid>
      </Grid>

      {errors.zip_code && errors.zip_code.message && (
        <p className={styles.errorMessage}>{errors.zip_code.message}</p>
      )}
    </div>
  )
}

export default CardForm;
